export const COMMON_BREADCRUMBS_IDS = {
  configuration: "configuration",
};
